import { render, staticRenderFns } from "./ExecutivoCard.vue?vue&type=template&id=d96550b0&scoped=true"
import script from "./ExecutivoCard.vue?vue&type=script&lang=js"
export * from "./ExecutivoCard.vue?vue&type=script&lang=js"
import style0 from "./ExecutivoCard.vue?vue&type=style&index=0&id=d96550b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96550b0",
  null
  
)

export default component.exports